var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import DataLayer from "@lonelyplanet/dotcom-core/dist/containers/dataLayer";
import { article, news, place, poi, video, } from "@lonelyplanet/open-planet-node/dist/openPlanetTypes";
import { Helmet } from "@lonelyplanet/travel-agent/dist/helmet";
import Tag from "backpack-ui/dist/components/tag";
import TagList from "backpack-ui/dist/components/tagList";
import * as cn from "classnames";
import * as fetch from "isomorphic-fetch";
import * as queryString from "query-string";
import * as React from "react";
import { Bling as GPT } from "react-gpt";
import { withRouter } from "react-router-dom";
import * as Sticky from "react-stickynode";
import Asset from "../../shared/components/asset";
import { adPositions, adSkyScraper, adSuperzone, adUnits, generateAdTargeting, } from "../../shared/utils/ads";
import Ad from "./components/ad";
import Container from "./components/container";
import Grid from "./components/grid";
import ListItemWireframe from "./components/listItemWireframe";
import NoResults from "./components/noResults";
import ResultsText from "./components/resultsText";
import { SearchForm } from "./components/searchForm";
import { SearchResults } from "./components/searchResults";
import * as styles from "./styles/search.css";
import cleanQuery from "./utils/cleanQuery";
var SearchComponent = /** @class */ (function (_super) {
    __extends(SearchComponent, _super);
    function SearchComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.tags = [
            [place, "Destinations"],
            [poi, "Things to do"],
            // Remove "narratives" and uncomment "narrative" when narratives are recrawled
            // [narrative, "Essential Information"],
            ["narratives", "Essential Information"],
            [video, "Video"],
            [article, "Articles"],
            [news, "News"],
        ];
        _this.filter = function (type) {
            _this.setState({
                type: type,
            }, function () {
                _this.updateQueryString();
                var newSearch = true;
                _this.fetchData(newSearch);
            });
        };
        _this.handleInfiniteScroll = function () {
            if (_this.state.results.length < _this.state.total) {
                _this.setState({
                    page: _this.state.page + 1,
                }, function () {
                    var newSearch = false;
                    _this.fetchData(newSearch);
                });
            }
        };
        _this.handleSearch = function (value) {
            _this.setState({
                keyword: value,
            }, function () {
                _this.updateQueryString();
                var newSearch = true;
                _this.fetchData(newSearch);
            });
        };
        _this.state = {
            isFetching: false,
            keyword: props.keyword || "",
            page: 1,
            results: props.results || [],
            total: props.total || 0,
            type: props.type,
        };
        return _this;
    }
    SearchComponent.prototype.componentDidMount = function () {
        if (!this.state.results.length) {
            this.initiateSearchFromQueryString();
        }
        if (this.state.keyword) {
            this.updateQueryString();
        }
    };
    SearchComponent.prototype.initiateSearchFromQueryString = function () {
        var _this = this;
        var searchQuery = queryString.parse(this.props.location.search);
        if (searchQuery.q && searchQuery.q !== this.state.keyword) {
            this.setState({
                keyword: searchQuery.q,
                type: searchQuery.type || null,
            }, function () {
                _this.fetchData(true);
            });
        }
    };
    SearchComponent.prototype.fetchData = function (newSearch) {
        return __awaiter(this, void 0, void 0, function () {
            var response, payload;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState({
                            isFetching: true,
                        });
                        return [4 /*yield*/, fetch("/search/api?q=" + cleanQuery(this.state.keyword) + "&page=" + (newSearch ? 1 : this.state.page) + (this.state.type ? "&type=" + this.state.type : ""))];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        payload = _a.sent();
                        if (newSearch) {
                            window.scrollTo(0, 0);
                            this.setState({
                                isFetching: false,
                                page: 1,
                                results: payload.data,
                                total: payload.total,
                            }, function () { return _this.updateInitialState(); });
                        }
                        else {
                            this.setState({
                                isFetching: false,
                                results: this.state.results.concat(payload.data),
                                total: payload.total,
                            }, function () { return _this.updateInitialState(); });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    SearchComponent.prototype.updateQueryString = function () {
        this.props.history.replace(this.getQueryString());
    };
    SearchComponent.prototype.render = function () {
        var _this = this;
        var _a = this.state, results = _a.results, total = _a.total, keyword = _a.keyword, isFetching = _a.isFetching;
        return (React.createElement(Container, null,
            React.createElement(DataLayer, { data: {
                    cd7_Topic: "search results",
                    content_group_1: "search",
                    content_group_2: "search results",
                    page_type: "search",
                    site_section: "search",
                } }),
            React.createElement(Asset, { src: "app.js" }),
            React.createElement(Helmet, null,
                React.createElement("title", null, "Search")),
            React.createElement(Sticky, { className: styles.searchBox, activeClass: styles.searchBoxSticky },
                React.createElement(Container, null,
                    React.createElement(SearchForm, { className: styles.searchForm, handleSearch: this.handleSearch, input: keyword }))),
            keyword && (React.createElement("div", { className: styles.filters },
                React.createElement(TagList, { limit: 10, style: {
                        height: "36px",
                        overflowX: "auto",
                        whiteSpace: "nowrap",
                    } }, this.tags.map(function (_a) {
                    var type = _a[0], name = _a[1];
                    return (React.createElement(Tag, { href: "#", selected: _this.state.type === type, key: type, onClick: function () {
                            return _this.filter(_this.state.type !== type ? type : null);
                        } }, name));
                })))),
            total > 0 &&
                keyword && (React.createElement(ResultsText, { className: styles.resultsText },
                total.toLocaleString("en"),
                " results for ",
                keyword)),
            React.createElement(Grid, { className: styles.contentArea },
                (isFetching || results.length > 0) && (React.createElement(Ad, { className: styles.ad },
                    React.createElement(GPT, { adUnitPath: adUnits.search, sizeMapping: [
                            { viewport: [0, 0], slot: [adSkyScraper, adSuperzone] },
                        ], targeting: generateAdTargeting({
                            position: adPositions.sideRail,
                            query: this.getQueryString(),
                        }) }))),
                React.createElement("div", { className: styles.results },
                    results &&
                        results.length > 0 && (React.createElement(SearchResults, { results: results, onScroll: this.handleInfiniteScroll })),
                    !isFetching &&
                        results &&
                        results.length === 0 &&
                        keyword && React.createElement(NoResults, { keyword: keyword }),
                    isFetching && (React.createElement(ListItemWireframe, { className: cn(results && results.length > 0 && styles.wireframe), animate: true }))))));
    };
    SearchComponent.prototype.updateInitialState = function () {
        window.__initialState.search = {
            keyword: this.state.keyword,
            results: this.state.results,
            total: this.state.total,
        };
    };
    SearchComponent.prototype.getQueryString = function () {
        var searchQuery = queryString.parse(this.props.location.search);
        Object.assign(searchQuery, {
            q: this.state.keyword,
            type: this.state.type,
        });
        return "?" + queryString.stringify(searchQuery);
    };
    return SearchComponent;
}(React.Component));
var wrapped = withRouter(SearchComponent);
export default wrapped;



//////////////////
// WEBPACK FOOTER
// ./app/modules/search/index.tsx
// module id = buU8
// module chunks = 2